import styled from "styled-components";

export const RefundButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 6,
  height: 34,
  ...theme.paddings(0, 12),
  border: `1px solid ${theme.palette.searchButtonBg}`,
  borderRadius: 6,
  backgroundColor: "transparent",
  color: theme.palette.searchButtonBg,
  fontSize: 13,
  fontWeight: 600,
  whiteSpace: "nowrap",
  cursor: "pointer",
  transition: "all .2s ease",

  "&:hover": {
    backgroundColor: theme.palette.searchButtonBg,
    color: theme.palette.white,
  },

  "& svg": {
    fontSize: 16,
  },
}));
